import React, { useState, useEffect } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import ProjectsList from "./../Projects/ProjectsList";
import { projects as getProjects } from '../../common/api/projects'
import logoWhite from '../../common/media/cc_logo_white.svg';
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration.js';
//IMPORTANT - THIS IS USED BY EMA AND STN TOO
const LandingPage = ({merchantCode, fetchedImpact}) => {
    const projects = fetchedImpact?.projects;

    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    const carsTakenOffRoad = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value/4600));
    const flyingHoursAvoided = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value/784));

    const numberOfCustomers = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.numberOfContributors?.value);

    return (
        <main>
            <header className='w-100 hero-img'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-md-5 p-my'>
                            <div className='clr_box'>
                            <h2 className='color-white'>Take Climate Action with SCP</h2>
                            <p className='mt-4 mb-4 color-white'>We’ve partnered with CarbonClick to make it simple to take climate action and reduce the impact of your purchase of an IBM LInuxONE Emperor 4 server.</p>
                            <div className="d-flex  powered-by justify-center">
                                <p className="m-0 mr-2 color-white text-subtitle">Powered by</p>
                                <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 26 }} src={logoWhite}/></a>
                            </div>
                            </div>
                        </div>
                        <div className='col-md-7 pr-0 text-right'> 
                            <img className='header-logo' src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1669364498/scp/carbon-click_wyexar.svg" alt='climate positive'/>
                        </div>
                    </div>
                </div>
            </header>

            <article id="content-scp" className="">
                <div className="container text-center">
                    <section className="center mw-800px">
                        <img className='scp-logo' src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1669368339/scp/image_91_pleeyv.svg" width={230} alt='SCP'/>
                        <h3 className="font-bold mb-0 ">We’ve gone Climate Positive and are here to help you. </h3>
                        <p>SCP has partnered with CarbonClick to become climate positive, by calculating and then DOUBLE offsetting our carbon emissions. To make sure your purchase is climate positive we can also calculate the emissions of your IBM LinuxONE Emperor 4 server and give you the option to offset those emissions - giving you a no-hassle, carbon neutral server.</p>
                    </section>
                </div>
            </article>

            <article id="scp-emission" className="">
                <div className="container text-center">
                    <section className="center mw-800px">
                        <h3 className="font-bold mb-0 ">How can I offset my emissions? </h3>
                        <p>When you purchase an IBM LinuxONE Emperor 4 server through us, we’ll show you the embodied and in-use emissions of the Emperor 4, wherever you choose to install in the world. With a wide range of offsetting projects available, we can match your Emperor 4 server with high impact projects from Australia and around the world.</p>
                    </section>
                </div>
            </article>

            <section className="scp-steps" id="">
                <div className="container nw-mw-800px">
                    <div className='row cp-step-wrapper'>
                        <div className='col-md-4'>
                            <h4> Calculate emissions</h4>
                            <img src='https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1669371531/scp/step1_graphic_uccvgk.svg' alt='Calculate emissions' />
                            <p>Calculate the emissions caused by your activity - reduce what you can and see what’s left</p>
                        </div>
                        <div className='col-md-4'>
                            <h4> Purchase offset</h4>
                            <img src='https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1669371531/scp/step2_graphic_fmjhvt.svg' alt='Purchase offset' />
                            <p>Purchase a carbon offset from meaningful climate projects for those emissions you cannot avoid</p>
                        </div>
                        <div className='col-md-4'>
                            <h4> Trace contribution</h4>
                            <img src='https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1669371531/scp/step3_graphic_hqebli.svg' alt='Trace contribution' />
                            <p>Receive a certificate and trace your contribution right to where your emissions have been offset </p>
                        </div>
                     </div>
                </div>
            </section>

            <section className="scp-cumulative" id="">
                <div className="container nw-mw-800px">
                    <div className='row scp-cumulative-wrapper'>
                        <div className='col-md-12'>
                            <h3 className="font-bold mb-0 "> Add to our cumulative impact and offset your emissions</h3>
                        </div>
                        <div className='col-md-12 d-flex cv-top-height'>
                            <div className='cv-top-wrapper'>
                            <img src='https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1669374604/scp/image_92_ajgwz6.svg' alt='SCP' />
                            <h2 className='mt-0'>{`${carbonOffsetImpact}  CO2-eq`}</h2>
                            <span className='cv-offset'> offset</span>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='row'>
                            <div className='col-md-6 cv-left-height'>
                                <div className='cv-left-wrapper'>
                                    <div>
                                        <h2 className='mt-0'>{numberOfCustomers}</h2>
                                        <span className='cv-offset'> customers taking climate action</span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6 w-3'>
                                <div className='row'>
                                    <div className='col-md-12 cv-right-height mb-16 cv-right-top-height'>
                                        <div className='cv-right-wrapper'>
                                        <div>
                                            <h2 className='mt-0'>{flyingHoursAvoided}</h2>
                                            <span className='cv-offset'>  cars taken off the road per year (equivalent)</span>
                                        </div>
                                        </div>
                                    </div>
                                    <div className='col-md-12 cv-right-height cv-right-btm-height'>
                                        <div className='cv-right-wrapper'>
                                        <div>
                                            <h2 className='mt-0'>{carsTakenOffRoad}</h2>
                                            <span className='cv-offset'>  hours of flying avoided (equivalent)</span>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container nw-mw-800px">
                    <div className='row sustainable-wrapper'>
                        <div className='col-md-12'>  
                            <h3 className="mt-0">Build a sustainable infrastructure</h3> 
                        </div>
                        <div className='col-md-12'>  
                            <div className="sus-content-wrap">
                                <img src='https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1669379176/scp/CustomImage_wcvqkz.svg' alt='sustainable' />
                                <div className='para'> 
                                    <p>SCP with the IBM® LinuxONE Emperor 4 helps you
achieve sustainability goals to reduce your energy
costs and carbon footprint with a secure, high-performance server platform for all your data-intensive workloads.</p><p>SCP will assist you calculate and then offset your associated emissions with your purchase of the IBM® LinuxONE Emperor 4, which will help in the fight against climate change and boost your sustainability credentials.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {Array.isArray(projects) &&
                <div className="global_blogs">
                    <div className="container text-center">
                        <div className="center mw-800px blog_heading">
                            <h3 className="font-bold">We are part of a global movement to fight climate change</h3>
                            <p className='mb-0'>We want to do something good for our local communities, but we are also aware that climage change is an issue that must be addressed at a global level. This is why we support some highest quality carbon offsetting projects  in Australia. </p>
                        </div>
                        <div className="text-align-start mobile-text-center mw-800px center">
                            <ProjectsList title={null} projects={projects} />
                        </div>
                    </div>
                </div>
            }
            <div className="faq_sec">
                <div className="container text-center">
                    <h3 className="font-bold">Climate Friendly FAQs</h3>
                    <div className="mb-3 center text-align-start mw-800px">
                        <Accordian title={"What does carbon offsetting do?"} >Carbon offsetting is a tool that allows individuals or companies to reduce their environmental impact. Purchasing carbon offsets supports environmental projects that remove greenhouse gases from the air, these projects could be things like reforestation projects or investment into renewable energy. Purchasing one carbon offset credit removes the equivalent of one tonne of CO<sub>2</sub> from the atmosphere.</Accordian>
                        <Accordian title={"Who are CarbonClick?"} >CarbonClick are a New Zealand-based company that exists to reverse climate change. CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective, building a happier and more sustainable future for everyone.</Accordian>
                        <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
                        <Accordian title={"Why should I offset?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
                        </div>
                    <a href="https://www.carbonclick.com/faq/" target="_blank" rel="noopener noreferrer" className="no-color-btn btn-primary btn-lg font-bold" >View all</a>
                    <div className="mobile-show py-5"></div>
                </div>
            </div>
            <footer className="img-cover footer-img scp-footer bg-grey" >
                <div className="container color-white mww-800px p-0">
                    <div className="d-flex">
                        <div className='d-column powered-by-wrap'>
                            <p className="m-0 mr-2 color-white text-subtitle">Powered by</p>
                            <a target="_blank" href={footerLinks?.carbonclick}><img style={{ height: 26 }} src={logoWhite} alt="Carbonclick logo" /></a>
                        </div>
                        <div className="right">
                            <div>
                                <a href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                    <img src={facebook} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                    <img src={instagram} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                    <img src={twitter} alt="carbonclick" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row">
                        <div className="col-4">
                            <div>                                
                                <div className="my-mb-3"><a className="color-white" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                                <div className=""><a className="color-white" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                            </div>
                        </div>
                        <div className="col-4 center">
                            <div>
                                <div className="my-mb-3"><a className="color-white" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                <div className=""><a className="color-white" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-4 text-right">
                            <div>                                
                                <div className="my-mb-3"><a className="color-white" href="mailto:hello@carbonclick.com" target="_blank" rel="noopener noreferrer">hello@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </main>
    )
}

//IMPORTANT - THIS IS USED BY EMA AND STN TOO
export default LandingPage;